import { createQueryStringToggleHook } from "../../../../stores/useQueryState";

export const useWheelBrands = createQueryStringToggleHook("brands", []);
